export const isValidValue = (val: any) => {
    return !!val || val === 0;
};

export const getSizeInPx = (size?: string | number) => {
    return typeof size === "number" ? `${size}px` : size;
};

export const getSizeInRem = (size?: string | number) => {
    // 1/16=0.0625, $sizeInPx/16=$sizeInPx*0.0625

    return typeof size === "number" ? `${size * 0.0625}rem` : size;
};

export const clampNumber = (
    value: number,
    min?: number,
    max?: number,
): number => {
    let result = value;
    if (isValidValue(max)) {
        result = Math.min(value, max!);
    }
    if (isValidValue(min)) {
        result = Math.max(result, min!);
    }
    return result;
};

export const getPriceString = (
    price: number = 0,
    optionOveride?: Pick<
        Intl.NumberFormatOptions,
        "style" | "currency" | "minimumFractionDigits" | "maximumFractionDigits"
    >,
) => {
    const defaultOption: Intl.NumberFormatOptions = {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    };

    return `${price.toLocaleString("en-IN", optionOveride || defaultOption)}`;
};

export const calculateDiscount = (
    originalPrice: number,
    discountValue: number,
    discountType: "percentage" | "amount" = "percentage",
) => {
    if (discountType === "percentage") {
        const discountAmount = (discountValue / 100) * originalPrice;
        const discountedPrice = originalPrice - discountAmount;
        return { discountAmount, discountedPrice, discountValue };
    } else if (discountType === "amount") {
        const discountPercentage = (discountValue / originalPrice) * 100;
        const discountedPrice = originalPrice - discountValue;
        return { discountValue, discountedPrice, discountPercentage };
    }
};
